module.exports = __webpack_public_path__ + "img/endocrino.3a3f26f9.png";